import { FunctionComponent } from 'react';
import { Typography, Input, Dialog } from './../../tailwindcomponents';

interface allowedDaysProps {
  visible: boolean,
  closeAllowedDaysDialog: Function,
  tool_description: string,
  days_allowed: string,
  onDaysAllowedChange: Function
}

const EditAllowedDays: FunctionComponent<allowedDaysProps> = ({ visible, tool_description, closeAllowedDaysDialog, days_allowed, onDaysAllowedChange }) => {
  return (
    <Dialog
      visible={visible}
      max_width={"md"} title={"Change allowed days"}
      context={
        <div className="w-full content-center items-center">
          <Typography variant="body1" align="center" text={tool_description} />
          <div className="ml-[35%]">
            <Input multiline={false} help_text={"Only numbers"} label_text={"How many days allowed"} value={days_allowed} onTextChange={(days: number) => onDaysAllowedChange(days)} type="number" width={40} />
          </div>
        </div>
      }
      onClose={(status: any) => closeAllowedDaysDialog(status)}
      strict={false}
      show_options={true}
    />
  );
};
export default EditAllowedDays